import { Component, Inject } from '@angular/core';
import { LoadingSpinnerComponent } from '../../../loading-spinner/loading-spinner.component';
import { FormMode } from '../../../../core/constants';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { AddCatalogItemDialogComponent } from '../add-catalog-item-dialog/add-catalog-item-dialog.component';
import { CatalogItem } from '../../../../models/catalog/catalogItem';

@Component({
  selector: 'app-edit-catalog-item-dialog',
  standalone: false,
  templateUrl: './edit-catalog-item-dialog.component.html',
})
export class EditCatalogItemDialogComponent {
  FormMode = FormMode;
  loadingSpinnerRef: MatDialogRef<LoadingSpinnerComponent> | undefined;
  itemId: string = '';
  catalogId: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddCatalogItemDialogComponent>,
    public loadingSpinnerDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      itemId: string;
      catalogId: string;
    },
  ) {
    this.itemId = data.itemId;
    if (!this.itemId || this.itemId == '') {
      throw 'Catalog item ID is required';
    }
    this.catalogId = data.catalogId;
    if (!this.catalogId || this.catalogId == '') {
      throw 'Catalog ID is required';
    }
  }

  handleSaved() {
    this.loadingSpinnerRef?.close();
    this.dialogRef.close({});
  }

  handleCancelled() {
    this.loadingSpinnerRef?.close();
    this.dialogRef.close();
  }
}
